"use strict";
var router = require('./router');
var revs = [2,6,8,12,14,18,22]
var urlMap = {}
var getKeyByValue = function(obj, value ) {
    for( var prop in obj ) {
        if( obj.hasOwnProperty( prop ) ) {
             if( obj[ prop ] === value )
                 return prop;
        }
    }
}
var prettyUrlMap = {
    "/news/pretty-url-here" : "10%20Things%3A%20Unlikely%20sports%20journeys",
    "pretty-url-here2" : "A%20walk%20through%20the%20wallflowers%3A%20Exploring%20McGill's%20visual%20arts%20collection",
    "pretty-url-here3" :"An%20exchange%20student's%20perspective%20on%20McGill%20Students",
    "pretty-url-here4" :"Behind%20the%20Scenes%20at%20McGill%20Athletics",
    "pretty-url-here5" : "Biochemist%20Nahum%20Sonenberg%20favours%20the%20prepared%20mind",
    "pretty-url-here6" : "Discouraged%20and%20overlooked%2C%20but%20still%20competing%3A%20A%20club%20athlete's%20experience%20at%20McGill",
    "pretty-url-here7" : "Establishing%20a%20Fall%20reading%20week%20at%20McGill",
    "pretty-url-here8" : "Simplicity%20in%20concept%2C%20duplicity%20in%20design%3A%20The%20precarious%20state%20of%20daily%20fantasy%20sports",
    "pretty-url-here9" : "The%20SSMU%20that%20students%20don't%20know",
    "pretty-url-here10" : "The%20Science%20and%20Policy%20Exchange%20group%20is%20planning%20for%20the%20future",
    "pretty-url-here11" : "The%20night%20owls%20of%20CKUT%20Radio",
    "pretty-url-here12" : "Three%20hole-in-the-wall%20resto-bars%20to%20celebrate%20the%20end%20of%20the%20semester",
    "pretty-url-here13" : "Unlisted%3A%20The%20secret%20weapon%20behind%20Redmen%20lacrosse",
    "pretty-url-here14" : "Up-and-coming%20fashion%20trends%20for%20students",
    "pretty-url-here15" : "When%20users%20perish%2C%20their%20social%20media%20accounts%20live%20on"
}
var App = {
    init: function(){
        router.load()
        var cols = ["<div class='col1'>", "<div class='col2'>", "<div class='col3'>"];
        router.templates.forEach(function(el, i){
            var element = router.templates[i],
                content2 = element.content,
                image = '<div class="img" style="background-image:url(' + element.image + ');"></div>',
                title = '<h3>' + element.title + '</h3>',
                author = '<h4>' + element.author + '</h4>',
                extra_open = "",
                extra_close = '';
            urlMap[encodeURIComponent(element.title)] = "#" +   i
            var toAdd =
                '<div class="article" id="' + i + '">' +
                    '<a href="#' + getKeyByValue(prettyUrlMap,encodeURIComponent(element.title)) + '">'
                    + "<div class='info'>"
                        + title
                        + author
                    + '</div>'
                    + image
                       + '</a>'
                    + '<div class="content">' + content2 + '</div>'
                + '</div>';
            if(i % 5 == 0 || revs.indexOf(i) > -1){
                 var toAdd =
                 '<div class="article" id="'+ i +'">' +
                    '<a href="#' + getKeyByValue(prettyUrlMap,encodeURIComponent(element.title))+ '">'
                    + image
                    + "<div class='info'>"
                        + title
                        + author
                    + '</div>'
                                   + '</a>'
                    + '<div class="content">' + content2 + '</div>'
                + '</div>';
            }

            cols[(i % 5 == 0 ? 0 : ((i + 1) % 5 == 0 ? 2 : 1))] += toAdd;
        });
        cols.forEach(function(el, i){
            cols[i] += "</div>"
        });
        $('#main').html(cols.join(" "));
        console.log(urlMap);
         var route = function(e){
            var source_id = urlMap[prettyUrlMap[location.hash.replace("#", '')]];
            console.log($(source_id))
            if (source_id === '') {
                $('.modal').removeClass('active');
            }
            else if ($(source_id).length > 0){
                $('#splash').addClass('inactive');
                var target = $('.modal');
                target.find('.articleTitle').html($(source_id).find('.info').find('h3').html())
                target.find('.articleAuthor').html($(source_id).find('.info h4').html())
                target.find('.headerImg').attr('src', $(source_id).find('.img').css('background-image').replace(/(url\()|\)/g, ""))
                target.find('.content').html($(source_id).find('.content').html())
                target.addClass('active')
                target.find('.articleContent').scrollTop(0);
            }
            else{
                $('.modal').removeClass('active');
            }
            ga('send', 'pageview', '/'+location.hash.replace("#", ''));
            DISQUS.reset({
              reload: true,
              config: function () {
                this.page.identifier = $(this).find('.info h3').html();
                this.page.url = window.location.href;
              }
            });
        };
        $(window).on('hashchange', route);
         $(window).on("scroll", function(){
                 $('#splash').addClass('inactive');
                  $(document).off("scroll");
            });
        route();
        router.templates;
    }
}

module.exports = App;